import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";
import { List, Map } from "immutable";

export interface IDisplayPreferenceState {
    currentViewName: string;
    currentView: List<Map<string, any>>;
    fetchingViews: boolean;
    rollupViews: { [key: string]: List<Map<string, any>> };
    rollupMerchantSavedViews: List<Map<string, any>>;
}

const initialState: IDisplayPreferenceState = {
    currentViewName: null,
    currentView: null,
    fetchingViews: false,
    rollupViews: undefined,
    rollupMerchantSavedViews: List(),
};

export const collectionItemDisplayPreference = handleActions<IDisplayPreferenceState>(
    {
        [COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.CURRENT_VIEW.CHANGE]: (
            state: IDisplayPreferenceState,
            { payload: { currentViewName, currentView } },
        ): IDisplayPreferenceState => {
            return {
                ...state,
                currentViewName: currentViewName ? currentViewName : state.currentViewName,
                currentView: currentView ? currentView : state.currentView,
            };
        },
        [COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.MERCHANT_ITEM_DISPLAY_PREFERENCE.FETCH.COMPLETED]: (
            state: IDisplayPreferenceState,
            { payload }: any,
        ): IDisplayPreferenceState => {
            const { merchantId, merchantSavedViews } = payload;
            if (merchantId && merchantSavedViews) {
                return {
                    ...state,
                    rollupMerchantSavedViews: merchantSavedViews,
                };
            }

            return {
                ...state,
            };
        },
    },
    initialState,
);
